import { type IncidentModel, IncidentSeverity, IncidentStatus } from '@models';

export function getRuleIncidentCountBySeverity(incidents: IncidentModel[]) {
  return incidents
    .filter(incident => incident.status !== IncidentStatus.RESOLVED)
    .reduce(
      (incidentCountBySeverity, incident) => ({
        ...incidentCountBySeverity,
        [incident.severity]: incidentCountBySeverity[incident.severity] + 1,
      }),
      {
        [IncidentSeverity.CRITICAL]: 0,
        [IncidentSeverity.MAJOR]: 0,
        [IncidentSeverity.MINOR]: 0,
      },
    );
}
